import styled from 'styled-components'
import PropTypes from 'prop-types'

const Hint = styled.small`
        color: ${props => props.color ? props.color : 'black'};
        display: inline-block;
        padding-left: 5px;
        &:before { content: "(" }
        &:after { content: ")" }
        font-weight: 200;
        font-style: italic;
    `

Hint.propTypes = {
    color: PropTypes.string,
}

export default Hint



// WEBPACK FOOTER //
// ./src/jsx/Components/Presentational/Atoms/Hint.jsx